import type { ApiColeta } from "pages/coleta/types/ApiColeta";
import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export function apiRelLitragemColeta({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<ApiColeta>> {
	return newRequest({
		url: "Relatorio/LitragemColeta",
		type: "get",
		idpk: undefined,
		params,
	});
}
